// extracted by mini-css-extract-plugin
export default {"questionPanel":"Question_questionPanel__yv4eL","questionPart":"Question_questionPart__jSg3M","expandBtn":"Question_expandBtn__jeK8F","answer":"Question_answer__rig0n"};